import React, { Component } from 'react'
import { Form, Checkbox, Grid, Header, Image, Icon} from 'semantic-ui-react'
import { connect } from 'react-redux'
import AddressForm from './addressForm'
import { DropDown } from '../formComponents/dropDown'
import CustomCheckBox from '../formComponents/checkBox'
import InputField from '../formComponents/inputField'
import * as actionCreators from '../actions'
import PscHeaderReason from "./headerReason";
import { get, trim } from 'lodash'
import { createItem } from '../api/createItem'
import {fetchSelectedReasonCodes, totalHeaderReasonSelected} from "../util";
import _ from 'lodash'



class ReconPageForm extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      midshownIndex: 0,
      showAllMids: false,
      showAddManfacc: false,
      newManfacIdz: "",
      midList_bv: [],
  }
  }

  render() {
    let {
      newValue,
      fieldName,
      setINPUTID,
      penClicked,
      shipmentId,
      reconInfo,
      updateReconField,
      saveReconField,
      isDisabled,
      updateAdditionalBondInfoField,
      saveHeaderReason,
      entryTypeValues,
      updateEntryTypeField,
      kxUserBasicInfo,
      createNotesItem,
      reconciliationIssueCodesList
    } = this.props
    const checked = entryTypeValues.reconciliationIssueCode && entryTypeValues.reconciliationIssueCode.length > 0
    return (<>
    <div>
      {/* <Checkbox
          isLabel={false}
          id='ReconInputcheckbox'
          label={ reconInfo.taReconCode?`${ reconInfo.taReconCode.replaceAll("_"," ").trim()} Recon`:'None'}
          className='field-bg'
          labelClassName='city'
          // value={bondInfoValues.suretyNumber}
          disabled={isDisabled("reconciliationIssueCode") || !reconInfo.taReconCode}
          checked={checked}
          onChange={value => {
            const popupText = `Are you sure you want to ${checked ? "disable" : "enable"} the Recon Flag` 
            if(window.confirm(popupText)) {
              let updatedData =  {reconciliationIssueCode: checked ? "OTHER_RECONCILATION_CODE" : reconInfo.taReconCode, tradeAgreementReconciliationIndicator: "N/A"}
              updateEntryTypeField("reconciliationIssueCode", checked ? undefined : reconInfo.taReconCode)
              saveReconField('reconInfo', {entryTypeInfo: updatedData})
              const noteDescription = `Broker has ${checked ? "removed" : "enabled"} the RECON flag.`
              createNotesItem(noteDescription, kxUserBasicInfo.fullName, false, () => {})
            }
          }}
      /> */}
      
      
      <DropDown
        id={"RECONCODEinput"}
        label={"RECON CODE"}
        disabled={isDisabled("reconciliationIssueCode")}
        className='field-bg dropdown100'
        labelClass='text-none'
        shipmentId={shipmentId}
        isLabel={true}
        data={[{text: "OTHER_RECONCILATION_CODE", description:"NONE"},...reconciliationIssueCodesList?.map((item)=>({ text:item.stringVal, description:item.stringVal}))]}
        text={(reconInfo?.taReconCode === "OTHER_RECONCILATION_CODE" || !reconInfo?.taReconCode) ? "NONE" : reconInfo?.taReconCode}
        onChange={value => {
          console.log(value)
          let localreconInfo = reconInfo;
          if(value?.text){
            localreconInfo.taReconCode = value?.text;
          } else {
            delete localreconInfo.taReconCode; 
          }
          updateEntryTypeField("reconciliationIssueCode", value?.text)
          // updateReconField('reconInfo', localreconInfo)
          // saveReconField('reconInfo', {reconInfo:localreconInfo})
          let updatedData =  {reconciliationIssueCode: value?.text, tradeAgreementReconciliationIndicator: trim(reconInfo?.taReconIndicator) || "N/A"}
          saveReconField('reconInfo', {entryTypeInfo: updatedData})
        }}
      />

                
      </div>
    </>
    )
  }
}

const mapStateToProps = (state, props) => {
  return ({
    reconInfo: state.ReconInfo,
    reconciliationIssueCodesList: state.DropDownValues.reconciliationIssueCodesList
})
}

const mapDispatchToProps = {
  ...actionCreators
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReconPageForm)